import React from 'react';
import logo1 from './logo1.png';
import logo2 from './logo2.png';
import logo3 from './logo3.png';
import logo4 from './logo4.png';
import logo5 from './logo5.png';
import logo6 from './logo6.png';

import css from './SectionLogos.module.css';

const SectionLogos = () => {
  return (
    <div className={css.wrapper}>
      <img className={css.logo} src={logo1} alt="Logo 1" />
      <img className={css.logo} src={logo2} alt="Logo 2" />
      <img className={css.logo} src={logo4} alt="Logo 4" />
      <img className={css.logo} src={logo5} alt="Logo 5" />
      <img className={css.logo} src={logo6} alt="Logo 6" />
      <img className={css.logo} src={logo3} alt="Logo 3" />
    </div>
  );
};

export default SectionLogos;
